<template lang="pug">
section
  s-page-title(title='Офисы компании')
    template(slot='extension')
      v-btn(@click='onEdit()' color='primary' depressed) Добавить
  v-card
    s-data-filter(@search='debouncedSearch' :initial='dataFilter.search')
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :total-items='total'
      :pagination='dataFilter'
      :rows-per-page-items='$config.rowsPerPageItems'
      @update:pagination='updatePaginiation'
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onEdit(props.item.id)')
          td(data-label='#ID') {{ props.item.id }}
          td(data-label='Регион') {{ props.item.region_name }}
          td(data-label='Город') {{ props.item.address_city }}
          td(data-label='Название') {{ props.item.office_name }}
          td(data-label='Адрес') {{ props.item.address_full }}
          td(class='text-xs-right wrapless crud-tools')
            v-btn(
              v-if='props.item.address_geo_lat && props.item.address_geo_lon'
              @click.stop='onShowMap(props.item)'
              icon
            )
              v-icon(small) outlined_flag
            v-btn(icon @click.stop='onDelete(props.item.id)')
              v-icon(small) delete_outline
  v-dialog(
    v-model='mapDialog'
    fullscreen
    hide-overlay
    transition='slide-x-reverse-transition'
  )
    v-card
      v-toolbar(flat color='white' class='toolbar')
        v-btn(icon @click.native='mapDialog = false')
          v-icon close
        v-toolbar-title {{ selectedOffice.office_name }}
      v-card-text(ref='yamap' class='yamap')
  v-dialog(
    v-model='mapLoadingDialog'
    hide-overlay
    persistent
    width='280'
  )
    v-card(color='primary' dark)
      v-card-text Загрузка карты
      v-progress-linear(indeterminate color='white' class='mb-0')
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import { loadScript } from '@/utils'

export default {
  data: () => ({
    headers: [
      { text: '#ID', align: 'left', value: 'id', width: '0%' },
      { text: 'Регион', align: 'left', value: 'region_name', width: '25%' },
      { text: 'Город', align: 'left', value: 'address_city', width: '25%' },
      { text: 'Название', align: 'left', value: 'office_name', width: '25%' },
      { text: 'Адрес', align: 'left', value: 'address_full', width: '20%' },
      { text: '', align: 'left', width: '0%', sortable: false }
    ],
    search: null,
    mapDialog: false,
    mapLoadingDialog: false,
    selectedOffice: {}
  }),

  beforeDestroy() {
    if (this.map) {
      this.map.destroy()
      delete this.map
    }
  },

  methods: {
    updatePaginiation(pagination) {
      this.setDataFilter(pagination)
      this.fetch()
    },

    async onDelete(id) {
      if (await this.$confirm('Удалить офис?')) {
        await this.destroy({ id })
        this.fetch()
      }
    },

    onEdit(id) {
      this.$router.push({
        name: 'Admin.Offices.Edit',
        params: { id }
      })
    },

    onShowMap(item) {
      this.mapLoadingDialog = true
      this.selectedOffice = item

      loadScript('https://api-maps.yandex.ru/2.1/?lang=ru_RU', () => {
        // eslint-disable-next-line
        ymaps.load(() => {
          this.mapLoadingDialog = false
          this.createYandexMap.apply(this, arguments)
        })
      })
    },

    createYandexMap({ address_geo_lat, address_geo_lon }) {
      this.mapDialog = true

      setTimeout(() => {
        if (!this.map) {
          // eslint-disable-next-line
          this.map = new ymaps.Map(this.$refs.yamap, {
            center: [55.75396, 37.620393],
            controls: [],
            zoom: 17
          })
        }

        // Удалим маркеры, которые были созданы ранее
        this.map.geoObjects.removeAll()

        // eslint-disable-next-line
        let placemark = new ymaps.Placemark(
          [address_geo_lat, address_geo_lon],
          {
            // TODO: можно создать свой собственный
            // шаблон для балуна или как его там
            balloonContentBody: `
              <address>
                <strong>${this.selectedOffice.office_name}</strong>
                <div>${this.selectedOffice.address_full}</div>
                <div><a href="/admin/offices/${this.selectedOffice.id}/edit">
                  Подробнее
                </a></div>
              </address>
            `
          },
          {
            preset: 'islands#governmentCircleIcon',
            iconColor: '#ff4e6b'
          }
        )

        this.map.geoObjects.add(placemark)

        this.map.setCenter([address_geo_lat, address_geo_lon], 18, {
          duration: 500
        })
      }, 500)
    },

    fetch() {
      this.fetchList({ config: { params: this.dataFilter } })
    },

    debouncedSearch: debounce(function(search) {
      this.setDataFilter({ search, page: 1 })
      this.fetch()
    }, 250),

    ...mapActions('admin/offices', ['fetchList', 'destroy']),
    ...mapMutations('admin/offices', ['setDataFilter'])
  },

  computed: {
    ...mapState('admin/offices', ['total', 'dataFilter']),
    ...mapGetters('admin/offices', ['list', 'isLoading'])
  }
}
</script>

<style scoped>
.yamap {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: absolute;
}
.toolbar {
  z-index: 10;
}
</style>
